<template>
  <div class="menu-bar" style="background-color: white">
    <b-row>
      <b-col v-if="mobile" cols="2">
        <Slide>
          <a id="tab-inicio" href="/" class="link">
            <span>Inicio</span>
          </a>
          <a id="tab-viviendas" href="/viviendas" class="link">
            <span>Viviendas</span>
          </a>
           <a id="tab-promociones" href="/promociones" class="link">
            <span>Promociones</span>
          </a>
          <a id="tab-locales" href="/locales" class="link">
            <span>Locales</span>
          </a>
          <a id="tab-oficinas" href="/oficinas" class="link">
            <span>Oficinas</span>
          </a>
          <a id="tab-fincas" href="/fincas" class="link">
            <span>Fincas</span>
          </a>
          <a id="tab-garajes" href="/garajes" class="link">
            <span>Garajes</span>
          </a>
          <a id="tab-contacto" href="/contacto" class="link">
            <span>Contacto</span>
          </a>
        </Slide>
      </b-col>
      <b-col :class="centerClass">
        <router-link to="/">
          <img src="/img/logo.png" width="200px" />
        </router-link>
      </b-col>
      <b-col class="menu-link" v-if="!mobile">
        <md-tabs class="md-accent" md-alignment="right" :md-active-tab="activeTab">
          <md-tab id="tab-inicio" href="/" md-label="Inicio"></md-tab>
          <md-tab id="tab-viviendas" href="/viviendas" md-label="Viviendas"></md-tab>
          <md-tab id="tab-promociones" href="/promociones" md-label="Promociones"></md-tab>
          <md-tab id="tab-locales" href="/locales" md-label="Locales"></md-tab>
          <md-tab id="tab-oficinas" href="/oficinas" md-label="Oficinas"></md-tab>
          <md-tab id="tab-fincas" href="/fincas" md-label="Fincas"></md-tab>
          <md-tab id="tab-garajes" href="/garajes" md-label="Garajes"></md-tab>
          <md-tab id="tab-contacto" href="/contacto" md-label="Contacto"></md-tab>
        </md-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  name: "menu-bar",
  components: {
    Slide
  },
  data() {
    return {
    };
  },
  computed: {
    centerClass: function() {
      if (this.mobile) {
        return "center";
      }
      return "";
    },
    activeTab: function() {
      const route = this.$route.path
        .substring(1)
        .toLowerCase()
        .split("-")[0];
      return "tab-" + (route ? route : "inicio");
    },
    mobile: function() {
        if( screen.width <= 760 ) {
            return true;
        } else {
            return false;
        }
    }
  }
};
</script>

<style>
.menu-bar {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 999;
}
.menu-bar img {
  padding: 10px;
}
.menu-link .md-tabs,
.menu-link .md-tabs .md-tabs-navigation,
.menu-link .md-tabs .md-tabs-navigation .md-tab-nav-button {
  height: 100%;
  color: #0085ca;
}
.menu-link .md-tabs .md-tabs-navigation .md-tab-nav-button:hover,
.menu-link .md-tabs .md-tabs-navigation .md-tab-nav-button.md-active {
  background-color: #0085ca;
  color: #fff;
}
a:hover {
  text-decoration: none !important;
}
.center {
  text-align: center;
}
.bm-burger-button {
  top: 22px !important;
}
.bm-burger-bars {
  background-color: #0085ca !important;
}
.bm-item-list {
  margin-left: 0 !important;
}
/*
.bm-menu {
  opacity: 90% !important;
}
*/
.link:hover, .link.active {
  background-color: #0085ca !important;
}
</style>
